import apiClient from '../client';

/**
 * Icon configuration
 */
export interface IconConfig {
  icon_type: string;
  icon_color?: string;
  icon_theme?: 'fill' | 'outline';
}

/**
 * CSS Style configuration
 */
export interface CssStyle {
  color?: string;
  weight?: number;
}

/**
 * Menu item structure
 */
export interface MenuItem {
  id?: string;
  code: string;
  url?: string;
  icon?: string | IconConfig;
  children?: MenuItem[];
  collapsable?: boolean;
  label_visible?: boolean;
  css_style?: CssStyle;
}

/**
 * Menu response
 */
export interface MenuResponse {
  menu: MenuItem[];
}

/**
 * Floating menu response
 */
export interface FloatingMenuResponse {
  floating_menu: string[];
}

/**
 * Menu API Service
 */
export const menuService = {
  /**
   * Get user menu
   */
  getMenu: async (): Promise<MenuItem[]> => {
    const { data } = await apiClient.get<MenuResponse>('/menu');
    return data.menu;
  },

  /**
   * Get floating menu items for current tenant
   * Returns list of menu item codes (e.g., "SIDE_MENU__MENU", "AI_CHAT__MENU")
   */
  getFloatingMenu: async (): Promise<string[]> => {
    const { data } =
      await apiClient.get<FloatingMenuResponse>('/menu/floating');
    return data.floating_menu;
  },
};
